var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentType,{tag:"component",attrs:{"joboffer":_vm.joboffer}})
}
var staticRenderFns = []

export { render, staticRenderFns }